export const servicePath = "https://macula.retinaarge.com.tr:5006";
export const apiPath = `${servicePath}/api`;
